import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getPostById } from "../services/posts";
import { RESTPost } from "../services/types";
import BDPost from "../components/BDPost";
import PostSkeleton from "../components/PostSkeleton";
import Header from "../components/Header";
import Button from "../components/Button";
import { useAuthenticatedAction } from "../hooks/useAuthenticatedAction";

const SinglePostPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [post, setPost] = useState<RESTPost | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const { execute: fetchPost } = useAuthenticatedAction();

    useEffect(() => {
        const postId = searchParams.get("p");
        
        if (!postId) {
            setError("No post ID provided");
            setLoading(false);
            return;
        }

        const loadPost = async () => {
            setLoading(true);
            setError(null);
            
            try {
                const postData = await fetchPost(getPostById, parseInt(postId, 10));
                setPost(postData);
            } catch (err: any) {
                setError(err.message || "Failed to load post");
                console.error("Error loading post:", err);
            } finally {
                setLoading(false);
            }
        };

        loadPost();
    }, [searchParams, fetchPost]);

    return (
        <div className="Page singlePostPage postsList">
            <Header />
            
            {error && (
                <div style={{ padding: "2rem", textAlign: "center" }}>
                    <p style={{ color: "red", marginBottom: "1rem" }}>{error}</p>
                    <Button onClick={() => navigate("/last")} variant="primary">
                        Retour aux BDs récentes
                    </Button>
                </div>
            )}

            {loading && <PostSkeleton />}

            {!loading && !error && post && <BDPost post={post} />}

            {!loading && !error && !post && (
                <div style={{ padding: "2rem", textAlign: "center" }}>
                    <p>Aucune BD trouvée.</p>
                    <Button onClick={() => navigate("/last")} variant="primary">
                        Retour aux BDs récentes
                    </Button>
                </div>
            )}
        </div>
    );
};

export default SinglePostPage;
